<template>
  <div>
    <v-label style="font-size: 16px">{{ label }}</v-label>
    <v-radio-group v-model="form" row class="mt-0">
      <v-radio
        v-for="(item, i) in items"
        :key="i"
        :label="item.text"
        :value="item.value"
        :disabled="disabled"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'FormRadio',
  props: ['label', 'required', 'items', 'value', 'disabled'],
  data() {
    return {
      form: this.value,
    };
  },
  methods: {
    mutate(value) {
      this.$emit('input', value);
    },

    setForm(value) {
      this.$set(this, 'form', value);
    },
  },
  watch: {
    form: 'mutate',
    value: 'setForm',
  },
};
</script>

<style scoped></style>
